import { QueryClient } from "@tanstack/react-query";
import { getCurrentUser } from "aws-amplify/auth";
import { PostHog } from "posthog-js";
import { LoaderFunctionArgs, redirect } from "react-router";
import { canAccessNewLogin } from "~/shared/lib/posthog/posthog.helper";
import { getRouteTreeRoot } from "../../api/users/users.helpers";
import { getUserType } from "../../api/users/users.queries";
import { useLoginStore } from "../LoginView/login.store";

export async function twoFactorAuthLoader(
  { request }: LoaderFunctionArgs,
  queryClient: QueryClient,
  posthogClient?: PostHog,
) {
  const url = new URL(request.url);
  const redirectTo = url.searchParams.get("redirectTo");

  if (canAccessNewLogin(posthogClient) && !useLoginStore.getState().canAccessRoute) {
    const loginRedirectUrl = `/login${redirectTo ? `?redirectTo=${redirectTo}` : ""}`;

    return redirect(loginRedirectUrl);
  }

  try {
    const user = await getCurrentUser();

    if (user) {
      try {
        const userType = await getUserType(queryClient);
        const routeTreeRoot = getRouteTreeRoot(userType);

        // Redirect to home if user is already logged in
        return redirect(redirectTo ?? routeTreeRoot);
      } catch (_error) {
        return null;
      }
    }
    return null;
  } catch (_error) {
    return null;
  }
}
